var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1View(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 38a8.75 8.75 0 11-17.502 0 8.75 8.75 0 0117.502 0zm23.8 0l-.63 1c-6.09 9.88-15.47 14-22.72 15.64a43.316 43.316 0 01-9.2 1.15h-.08a43.316 43.316 0 01-9.14-1.14C21.51 53 12.13 48.88 6 39l-.63-1L6 37c6.13-9.88 15.51-14 22.76-15.64a43.322 43.322 0 019.14-1.14h.1c3.078.054 6.142.437 9.14 1.14C54.45 23 63.83 27.12 69.92 37l.63 1zm-4.74 0s-.13-.18-.15-.22C57.12 25.44 42.39 24.27 38 24.21h-.08c-4.37.06-19.1 1.23-27.63 13.57 0 0-.17.18-.15.22.02.04.12.18.15.22 8.53 12.34 23.26 13.51 27.63 13.57H38c4.37-.06 19.1-1.23 27.64-13.57.04-.04.19-.22.17-.22z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_View.30150d05.svg";
export { SvgK1View as ReactComponent };